import { FaWhatsapp } from "react-icons/fa";

export default function BotaoWhatsapp() {
  const telefone = "5531993127020";
  const mensagem = "Olá! Gostaria de mais informações sobre um orçamento.";
  const link = `https://wa.me/${telefone}?text=${encodeURIComponent(mensagem)}`;

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Abrir conversa no WhatsApp"
      className="fixed bottom-20 right-0 z-50 bg-[#C9AA7B] text-white w-12 h-12 flex items-center justify-center rounded-l-full shadow-lg transform translate-x-1/2 hover:scale-110 transition-all duration-300 animate-pulse-scale"
    >
      <FaWhatsapp className="text-xl" />
    </a>
  );
}
